const PAPERWORK_LINK_TOKEN = `{{paperwork.link}}`

export const PAPERWORK_LINK_PATTERN = /\{\{\s*paperwork\.link\s*\}\}/

export const DEFAULT_PAPERWORK_EXPIRY_DAYS = 14

export const DEFAULT_PAPERWORK_MESSAGE = `Hi {{contact.firstName}}, please fill out your paperwork before your visit: ${PAPERWORK_LINK_TOKEN}`
